import { render, staticRenderFns } from "./logisticsIndex.vue?vue&type=template&id=3465cf66&scoped=true"
import script from "./logisticsIndex.vue?vue&type=script&lang=js"
export * from "./logisticsIndex.vue?vue&type=script&lang=js"
import style0 from "./logisticsIndex.vue?vue&type=style&index=0&id=3465cf66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465cf66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3465cf66')) {
      api.createRecord('3465cf66', component.options)
    } else {
      api.reload('3465cf66', component.options)
    }
    module.hot.accept("./logisticsIndex.vue?vue&type=template&id=3465cf66&scoped=true", function () {
      api.rerender('3465cf66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/stockManagement/logisticsIndex.vue"
export default component.exports